<template>
    <section class="relative t3m-Section t3m-FlxBillboard isolate"
             ref="billboard">
        <div class="relative t3m-FlxBillboard-row md:pt-[34%]">
            <div class="bg-black t3m-FlxBillboard-pane md:absolute md:left-0 md:top-0 md:w-full md:h-[56.25vw]">
                <div class="absolute inset-0 t3m-FlxBillboard-media t3m-u-flx-inset">
                    <transition :name="initialState ? undefined : 'fade'"
                                :mode="initialState ? undefined : 'out-in'"
                                @after-enter="afterEnter">
                        <div class="absolute inset-0 overflow-hidden t3m-FlxBillboard-imageWrapper t3m-u-flx-inset"
                             :key="getImage"
                             :class="getTheme"
                             style="animation-duration: 300ms">
                             <img v-if="!getVideo"
                                    class="object-cover w-full h-full t3m-FlxBillboard-image"
                                    :src="isMobile() ? getImageMobile : getImage"
                                    :srcset="getImageSrcSet"
                                    sizes="100vw"
                                    loading="eager"
                             :alt="getTitle" />
                            <video v-if="getVideo && !isMobile()"
                                   ref="video"
                                   :src="getVideo"
                                   width="1920"
                                   height="1080"
                                   :poster="getImage"
                                   muted
                                   loop
                                   playsinline
                                   preload="metadata"
                                   class="object-cover w-full h-full t3m-FlxBillboard-video"
                                   @canplay="playVideo"></video>
                            <div class="absolute inset-0 bg-opacity-50 bg-gradient-to-r md:bg-transparent"
                                 :class="{
                                     'from-white bg-white': getTheme === 'light',
                                     'from-black bg-black': getTheme === 'dark',
                                 }"></div>
                        </div>
                    </transition>
                    <div class="t3m-FlxBillboard-vignette absolute inset-x-0 h-[14.7vw] -bottom-px bg-gradient-to-t from-gray-900"
                         :class="getTheme"></div>
                </div>

                <div
                     class="relative top-0 flex flex-col pt-16 t3m-FlxBillboard-text-container md:min-h-auto min-h-[40vh] container-fluid md:absolute md:inset-x-0 md:bottom-0">
                    <div class="relative z-10 flex flex-col justify-center max-w-2xl t3m-FlxBillboard-text md:h-1/2">
                        <transition :name="initialState ? undefined : 'fade'"
                                    :mode="initialState ? undefined : 'out-in'">
                            <div v-if="this.billboardItem"
                                 class="t3m-FlxBillboard-text-inner"
                                 :class="{
                                     'text-t3m-body': getTheme === 'light',
                                     'text-white': getTheme === 'dark',
                                 }"
                                 :key="getTitle"
                                 style="animation-duration: 300ms">

                                <h1 v-if="pageTitle"
                                    v-html="pageTitle"
                                    class="hidden opacity-80 py-1.5 px-2 text-sm rounded-sm font-normal border border-t3m-body mb-6 t3m-FlxBillboard-pageTitle"
                                    :class="{
                                        'text-white !border-white': getTheme === 'dark',
                                        '!inline-block': !isCurrentPage
                                    }"></h1>
                                <h2 v-if="getTitle"
                                    v-html="getTitle"
                                    class="mb-6 !font-bold t3m-FlxBillboard-title 2xl:text-5xl"></h2>

                                <div class="mb-6 xl:text-lg 2xl:text-xl t3m-FlxBillboard-abstract"
                                     v-html="getAbstract"></div>
                                <p v-if="getLink">
                                    <a :href="getLink"
                                       class="mt-4 btn btn-primary btn-md"
                                       :aria-label="getLinkLabel">{{ getLinkLabel }}</a>
                                </p>
                            </div>
                        </transition>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { utilities } from "@/shared";
import { mapState, mapActions } from "vuex";


export default {
    name: "Billboard",
    props: {},
    mixins: [utilities],
    computed: {
        ...mapState(["pageTitle", "billboardItem", "initialState"]),
        getTitle: function () {
            return this.billboardItem?.title;
        },
        getAbstract: function () {
            return this.billboardItem?.abstract;
        },
        getImage: function () {
            return this.billboardItem?.image;
        },
        getImageSrcSet: function () {
            return this.billboardItem?.imageSrcSet;
        },
        getImageMobile: function () {
            return this.billboardItem?.imageMobile;
        },
        getImageSrcSetMobile: function () {
            return this.billboardItem?.imageSrcSetMobile;
        },
        getVideo: function () {
            return this.billboardItem?.video;
        },
        getLink: function () {
            return this.billboardItem?.link;
        },
        getTheme: function () {
            return this.billboardItem?.theme;
        },
        getLinkLabel: function () {
            return this.billboardItem
                ? this.billboardItem.customLinkLabel || this.billboardItem.linkLabel || "Read More"
                : "Read More";
        },
        isCurrentPage: function () {
            return this.billboardItem?.isCurrentPage;
        },
    },
    methods: {
        ...mapActions(["invalidateInitialState"]),
        playVideo() {
            if (this.paused) {
                return;
            }
            this.$refs.video.play();
        },
        afterEnter() {
            this.invalidateInitialState();
        },
    },
};


</script>
